<template>
  <StageScaler>
    <TextQnAPublishedStage
      data-testid="text-qna-published-stage"
      :logo="$store.getters['branding/theme_obj'].logo_url"
      :demoButtonText="$store.getters['branding/theme_obj'].demo_request_button_text"
      :showDemoLink="$store.getters['branding/theme_obj'].demo_link_enabled"
      :targets="$store.getters['branding/currentTargets']"
      :showScreenSaver="$store.getters['branding/theme_obj'].onEditScreenSaver"
      :navigatorLinks="$store.getters['branding/navigatorLinks']"
      :stageChatTabs="$store.getters['branding/stageChatTabs']"
      :sidebarPrimaryTabs="$store.getters['branding/sidebarPrimaryTabs']"
    />
  </StageScaler>
</template>

<script>
import { TextQnAPublishedStage } from '@goldcast/uicomponents-branding';

import StageScaler from './StageScaler.vue';

export default {
  name: 'TextQnAPublishedStagePreview',
  components: { TextQnAPublishedStage, StageScaler }
};
</script>
